<template>
  <form @submit.prevent="validateBeforeSubmit">
    <div class="flex flex-wrap flex-space" v-if="!success">
      <div :class="'md:w-' + group.width.replace('-', '/').replace('1/1', 'full')" v-for="group in formFields.groups" :key="group.id">
        <div v-if="group.legend">
          <div class="text-2xl mb-5" v-html="group.legend"></div>
        </div>
        <div class="flex flex-wrap flex-space">
          <div :class="field.width || 'w-full'" v-for="field in group.fields" :key="field.name">
            <template v-if="showField(field.condition)">
              <!--<component v-bind:is="'app-' + field.type"></component>-->
              <template v-if="field.type === 'honeypot'">
                <app-input
                  :type="field.type"
                  :name="field.name"
                  :id="'form_' + field.name"
                  classes="email"
                  v-model="form[field.name]"
                ></app-input>
              </template>
              <template v-if="field.type === 'text' || field.type === 'number'">
                <app-label :forInput="field.name" class="block text-sm" v-if="field['label_position'] === 'label'">
                  {{ $t(field.label) }}
                  <span v-if="field.rules.indexOf('required') !== -1">*</span>
                </app-label>
                <app-input
                  :type="field.type"
                  :name="field.name"
                  :id="'form_' + field.name"
                  :classes="field.classes || ''"
                  v-model="form[field.name]"
                  v-validate="{ required: field.rules.indexOf('required') !== -1 }"
                  :error="errors.first(field.name)"
                  :placeholder="field['label_position'] === 'placeholder' ? $t(field.label) + (field.rules.indexOf('required') !== -1 ? '*' : '') : field.placeholder || ''"
                ></app-input>
              </template>
              <template v-if="field.type === 'calendar'">
                <app-label :forInput="field.name" class="block text-sm" v-if="field['label_position'] === 'label'">
                  {{ $t(field.label) }}
                  <span v-if="field.rules.indexOf('required') !== -1">*</span>
                </app-label>
                <app-calendar
                  :type="field.type"
                  :name="field.name"
                  v-model="form[field.name]"
                  v-validate="{ required: field.rules.indexOf('required') !== -1 }"
                  :error="errors.first(field.name)"
                  :placeholder="field['label_position'] === 'placeholder' ? $(field.label) + (field.rules.indexOf('required') !== -1 ? '*' : '') : ''"
                  :id="'form_' + field.name"
                ></app-calendar>
              </template>
              <template v-if="field.type === 'datepicker'">
                <app-label :forInput="field.name" class="uk-form-label" v-if="field['label_position'] === 'label'">
                  {{ $t(field.label) }}
                  <span v-if="field.rules.indexOf('required') !== -1">*</span>
                </app-label>
                <app-datepicker
                  :type="field.type"
                  :name="field.name"
                  v-model="form[field.name]"
                  v-validate="{ required: field.rules.indexOf('required') !== -1 }"
                  :error="errors.first(field.name)"
                  :placeholder="field['label_position'] === 'placeholder' ? $t(field.label) + (field.rules.indexOf('required') !== -1 ? '*' : '') : ''"
                  :id="'form_' + field.name"
                ></app-datepicker>
              </template>
              <template v-if="field.type === 'textarea'">
                <app-label :forInput="field.name" class="block text-sm" v-if="field['label_position'] === 'label'">
                  {{ $t(field.label) }}
                  <span v-if="field.rules.indexOf('required') !== -1">*</span>
                </app-label>
                <app-textarea
                  :name="field.name"
                  v-model="form[field.name]"
                  :val="field.value"
                  :label="$t(field.label)"
                  :rows="field.rows"
                  :placeholder="field['label_position'] === 'placeholder' ? $t(field.label) + (field.rules.indexOf('required') !== -1 ? '*' : '') : ''"
                  :errors="formErrors[field.name]"
                ></app-textarea>
              </template>
              <template v-if="field.type === 'select' || field.type === 'select-value'">
                <app-label :forInput="field.name" class="block text-sm" v-if="field['label_position'] === 'label'">
                  {{ $t(field.label) }}
                  <span v-if="field.rules.indexOf('required') !== -1">*</span>
                </app-label>
                <app-select
                  v-if="field.type === 'select'"
                  :name="field.name"
                  :options="field.options"
                  v-model="form[field.name]"
                  v-validate="{ required: field.rules.indexOf('required') !== -1 }"
                  :error="errors.first(field.name)"
                  :placeholder="field['label_position'] === 'placeholder' ? $t(field.label) + (field.rules.indexOf('required') !== -1 ? '*' : '') : ''"
                  :errors="formErrors[field.name]"
                ></app-select>
                <app-select-value
                  v-else
                  :name="field.name"
                  :options="field.options"
                  v-model="form[field.name]"
                  v-validate="{ required: field.rules.indexOf('required') !== -1 }"
                  :error="errors.first(field.name)"
                  :placeholder="field['label_position'] === 'placeholder' ? $t(field.label) + (field.rules.indexOf('required') !== -1 ? '*' : '') : ''"
                  :errors="formErrors[field.name]"
                ></app-select-value>
              </template>
              <template v-if="field.type === 'make-models'">
                <app-label :forInput="field.name" class="block text-sm" v-if="field['label_position'] === 'label'">
                  {{ $t(field.label) }}
                  <span v-if="field.rules.indexOf('required') !== -1">*</span>
                </app-label>
                <app-make-models
                  :placeholder="field['label_position'] === 'placeholder' ? $t(field.label) + (field.rules.indexOf('required') !== -1 ? '*' : '') : ''"
                  :errors="formErrors[field.name]"
                  @change="onMakeModelChange"
                ></app-make-models>
              </template>
              <template v-if="field.type === 'upload'">
                <div class="mb-4">
                  <div v-html="$t(field.label)" class="mb-4"></div>
                  <file-upload url="/v1/forms/image-upload" :data="{ id: id }" @uploaded="addImageUuid" @removed="removeImageUuid"></file-upload>
                </div>
              </template>
              <template v-if="field.type === 'checkbox' && field.name !== 'privacy'">
                <app-checkbox
                  :label="field.label"
                  :value="field.value"
                  :name="field.name"
                  v-model="form[field.name]"
                  :shouldValidate="field.rules.indexOf('required') !== -1"
                  :error="errors.first(field.name)"
                  :text-small="field.options.textsize === 'small'"
                ></app-checkbox>
              </template>
              <template v-if="field.type === 'checkbox-group'">
                <app-checkbox-group :label="$t(field.label)" :options="field.options" v-model="form[field.name]"
                                    :errors="formErrors[field.name]"></app-checkbox-group>
              </template>
              <template v-if="field.type === 'radio'">
                <app-radio
                  :label="$t(field.label)"
                  :initial-value="field.value"
                  :name="field.name"
                  :options="field.options"
                  v-model="form[field.name]"
                  :shouldValidate="field.rules.indexOf('required') !== -1"
                  :error="errors.first(field.name)"
                ></app-radio>
              </template>
              <template v-if="field.type === 'textField'">
                <app-text :value="field.value"></app-text>
              </template>
            </template>
          </div>
        </div>
      </div>
      <div id="anMailContainer" class="anMailContainer">
        <label for="an_field_s">Field:</label>
        <input type="text" id="an_field_s" name="an_field_s" v-model="form.an_field_s">
      </div>
      <span class="an_hidden_field" style="display:none;height:0;width:0;">
        <label>AN <input type="text" :name="hiddenFormFieldName" v-model="form.hiddenFormField" /></label>
      </span>
      <div class="mb-4">
        <p class="text-xs">{{ $t('*Pflichtfelder') }}</p>
        <p class="text-red-600" v-if="errors.items.length">
          {{ $t('Bitte Pflichtfelder beachten!') }}
        </p>
        <p class="text-sm">Unsere Datenschutzerklärung finden Sie <a class="font-medium text-primary hover:underline" href="/datenschutz/" target="_blank">hier</a>.</p>
        <button type="submit" class="flex items-center btn btn-primary disabled:cursor-not-allowed"
                :disabled="waiting" @click.prevent="validateBeforeSubmit">
          <div v-if="waiting">
            <svg aria-hidden="true" class="inline size-4 text-gray-200 animate-spin fill-gray-500" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
              <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
            </svg>
            <span class="sr-only">Loading...</span>
          </div>
          <span v-if="!waiting">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" stroke-width="1.5"
                   stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
              <path d="M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10z"></path>
              <path d="M3 7l9 6l9 -6"></path>
            </svg>
          </span>
          <span class="ml-1">{{ $t('Absenden') }}</span>
        </button>
      </div>
    </div>

    <div class="m-auto max-w-6xl" v-else>
      <div class="flex justify-center text-center mt-12">
        <div class="w-full">
          <div class="p-4">
            <div class="font-bold">
              <div class="text-lg">{{ $t('Vielen Dank für Ihre Anfrage') }}</div>
            </div>
            <div>
              <p>
                {{ $t('Wir werden uns mit Ihnen in kürzester Zeit in Verbindung setzen.') }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import axios from 'axios'
import AppInput from './tailwind/form/input.vue'
import AppTextarea from './tailwind/form/textarea.vue'
import AppSelect from './tailwind/form/select.vue'
import AppSelectValue from './tailwind/form/select-value.vue'
import AppMakeModels from './form/make-models.vue'
import AppLabel from './tailwind/form/label.vue'
import AppCheckbox from './tailwind/form/checkbox.vue'
import AppCheckboxGroup from './form/checkbox-group.vue'
import AppRadio from './form/radio.vue'
import FileUpload from './tailwind/upload/FileUpload.vue'
import AppCalendar from './form/calendar.vue'
import AppDatepicker from './form/datepicker.vue'
import AppText from './form/text.vue'

import Vue from 'vue'
import VeeValidate from 'vee-validate'

//import { VueReCaptcha } from 'vue-recaptcha-v3'

Vue.use(VeeValidate)
//Vue.use(VueReCaptcha, { siteKey: window.captcha })

export default {
  props: {
    id: {
      required: true,
    },
    successMessage: {
      required: false,
    },
    extraData: {
      required: false,
    },
    settings: {
      required: false,
    },
    prefill: {
      required: false,
    },
    prefillDealer: {
      required: false,
    },
    reloadPage: {
      required: false,
    },
  },

  components: {
    AppInput,
    AppTextarea,
    AppSelect,
    AppSelectValue,
    AppCheckbox,
    AppCheckboxGroup,
    AppLabel,
    FileUpload,
    AppRadio,
    AppMakeModels,
    AppCalendar,
    AppText,
    AppDatepicker,
  },

  data() {
    return {
      form: {
        images: [],
        privacy: false,
      },
      formFields: [],
      formErrors: {},
      waiting: false,
      success: false,
      mergedExtraData: {},
      languages: ['de', 'en', 'es', 'fr', 'it', 'ro', 'pl', 'pt-pt', 'ru'],
      captchaVerified: false,
      hiddenFormFieldName: ''
    }
  },

  mounted() {
    const hiddenFormField = window.ansolution_base_form_field_info
    this.hiddenFormFieldName = hiddenFormField.field_name
    this.form.an_field_name = hiddenFormField.field_value
    this.form.an_field_s = ''

    const checkedLang = window.location.pathname.split('/')[1]
    if (this.languages.includes(checkedLang)) {
      this.$i18n.locale = checkedLang
    } else {
      this.$i18n.locale = 'de'
    }
    this.getFields()

    if (this.localExtraData) {
      this.mergedExtraData = this.localExtraData
    }

    if (this.settings) {
      _.forEach(this.settings, (v, k) => {
        this.mergedExtraData[k] = v
      })
    }

    if (this.prefillDealer) {
      const dealerData = JSON.parse(window.kfzDealer)[0]

      this.form.name = dealerData.company
      this.form.email = dealerData.email
      this.form.telefon = dealerData.phone
    }

    if (this.prefill) {
      const prefillData = JSON.parse(this.prefill)
      _.forEach(prefillData, (v, k) => {
        this.form[k] = v
      })
    }
  },

  computed: {
    localExtraData() {
      return typeof this.extraData !== 'undefined' ? JSON.parse(this.extraData) : null
    },
  },

  methods: {
    showField(condition) {
      if (typeof condition !== 'undefined' && condition.split('_').length === 2) {
        const splitted = condition.split('_')
        if (this.form[splitted[0]] === true || this.form[splitted[1]] === true) {
          return true
        }

        if (this.form[splitted[0]] === 'true' || this.form[splitted[1]] === 'true') {
          return false
        }

        if (typeof this.form[splitted[0]] === 'undefined' || (typeof this.form[splitted[0]] !== 'undefined' && this.form[splitted[0]] !== splitted[1])) {
          return false
        }
      }
      if (typeof this.form[condition] !== 'undefined' && (this.form[condition] === 'Nein' || this.form[condition] === true)) {
        return false
      }
      return true
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        //if(typeof window.knumber !== 'undefined' && window.knumber === 'K10038') { // a1a only
        //  if(typeof _.find(this.errors.items, e => e.field === 'privacy') !== 'undefined') {
        //    this.form.privacy = true
        //     this.$validator.reset();
        //  }
        //}
        if (result) {
          //this.$recaptchaLoaded().then(() => {
          //  console.log('recaptcha loaded')
          //  this.$recaptcha('login').then((toke¶n) => {
          this.submit()
          //  })
          //})
        }
      })
    },
    getFields() {
      axios.get(`/wp-json/ansolution/v1/forms/${this.id}`).then((response) => {
        /*
        fields.groups.push({id:null, fields: [{
            label: 'E-Mail',
            label_position: null,
            name: 'wvb9gne24',
            rules: ["required", "email"],
            type: 'email',
            classes: 'email'
          }]})
         */
        this.formFields = response.data.fields
      })
    },
    onMakeModelChange(data) {
      _.forEach(data, (v, k) => {
        this.form[k] = v
      })
    },
    onCaptchaVerify(token, eKey) {
      this.captchaVerified = true
    },
    onCaptchaExpire: () => {
      //console.log('Token expired')
    },
    onCaptchaError: (err) => {
      //console.log('Error', err)
    },
    async submit() {
      this.waiting = true
      this.success = false
      try {
        axios
          .post('/wp-json/ansolution/v1/forms/' + this.id + '/message', Object.assign({},this.form, {extraData: this.mergedExtraData}))
          .then(() => {
            this.waiting = false
            this.success = true
            this.form = {
              images: [],
              privacy: true,
            }
            this.formErrors = {}

            if (this.reloadPage) {
              setTimeout(() => {
                window.location.reload()
              }, 5000)
            }

            setTimeout(() => {
              this.success = false
            }, 10000)
          })
          .catch((error) => {
            this.waiting = false
            this.success = false
            this.formErrors = error.response.data
          })
      } catch (error) {
        this.waiting = false
        this.success = false
        //console.log(error);
      }

    },

    addImageUuid(data) {
      this.form.images.push(data)
    },
    removeImageUuid(index) {
      this.form.images.splice(index, 1)
    },
  },
}
</script>

